import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import ServeurHome from './pages/serveur/ServeurHome';
import PriseCommande from './pages/serveur/PriseCommande';
import CuisineHome from './pages/cuisine/CuisineHome';
import CaisseHome from './pages/caisse/CaisseHome';


// Route protégée selon le rôle
const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  
  if (loading) return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-white text-2xl">Chargement...</div>
    </div>
  );
  
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" />;
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/serveur" element={
            <ProtectedRoute roles={['serveur', 'admin']}>
             <ServeurHome />
            </ProtectedRoute>
          } />
          <Route path="/serveur/commande/:tableId" element={
  <ProtectedRoute roles={['serveur', 'admin']}>
    <PriseCommande />
  </ProtectedRoute>
} />
          <Route path="/cuisine" element={
            <ProtectedRoute roles={['cuisine', 'admin']}>
             <CuisineHome />          
              </ProtectedRoute>
          } />
          <Route path="/caisse" element={
            <ProtectedRoute roles={['caisse', 'admin']}>
<CaisseHome />            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;